import App from "./App";

window.App = App;



// WEBPACK FOOTER //
// ./Components/Entry.jsx